export const RedCircleCheck = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      {...props}
    >
      <path
        d='M6.06683 10.0668L10.7668 5.36683L9.8335 4.4335L6.06683 8.20016L4.16683 6.30016L3.2335 7.2335L6.06683 10.0668ZM7.00016 13.6668C6.07794 13.6668 5.21127 13.4918 4.40016 13.1418C3.58905 12.7918 2.8835 12.3168 2.2835 11.7168C1.6835 11.1168 1.2085 10.4113 0.858496 9.60016C0.508496 8.78905 0.333496 7.92239 0.333496 7.00016C0.333496 6.07794 0.508496 5.21127 0.858496 4.40016C1.2085 3.58905 1.6835 2.8835 2.2835 2.2835C2.8835 1.6835 3.58905 1.2085 4.40016 0.858496C5.21127 0.508496 6.07794 0.333496 7.00016 0.333496C7.92239 0.333496 8.78905 0.508496 9.60016 0.858496C10.4113 1.2085 11.1168 1.6835 11.7168 2.2835C12.3168 2.8835 12.7918 3.58905 13.1418 4.40016C13.4918 5.21127 13.6668 6.07794 13.6668 7.00016C13.6668 7.92239 13.4918 8.78905 13.1418 9.60016C12.7918 10.4113 12.3168 11.1168 11.7168 11.7168C11.1168 12.3168 10.4113 12.7918 9.60016 13.1418C8.78905 13.4918 7.92239 13.6668 7.00016 13.6668Z'
        fill='#FF0037'
      />
    </svg>
  );
};
